
import { Quote } from "@/utils/dto/objects.js";
import IconView from "@/components/objects/IconView.vue";

export default {
  name: "Default",
  components: { IconView },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    quote: {
      type: [Quote, Object]
    },
    objectLabel: {
      type: String
    },
    color: {
      type: String
    },
    template: {
      type: Object
    },
    listInfo: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => { }
    },
  },
}
